// import { useEffect, useMemo, useState } from "react";
// import Card from "react-bootstrap/Card";
// import { RBTable } from "@pallassystems/react-bootstrap-table";
// import Breadcrumb from "app/components/Breadcrumb";
// import { axios } from "fake-db/mock"; 

// export default function Leave() {
//   const [users, setUsers] = useState([]);

  
//   useEffect(() => {
//     axios
//       .get("/api/user/all")
//       .then((res) => {
//         console.log("Leave API Response:", res.data);

//         // Map API response to table structure
//         const leaveTypes = ["Casual Leave", "Sick Leave", "Paid Leave"];
//         const departments = ["HR", "IT", "Admin", "Sales"];
//         const durations = ["1 Day", "2 Days", "3 Days"];
//         const statuses = ["Pending", "Approved", "Rejected"];

//         const list = (res.data || []).map((user, index) => ({
//           leaveType: leaveTypes[index % leaveTypes.length],
//           department: departments[index % departments.length],
//           duration: durations[index % durations.length],
//           appliedDate: `0${(index % 9) + 1}-01-2026`, // generates 01-01-2026 to 09-01-2026
//           status: statuses[index % statuses.length],
//         }));

//         setUsers(list);
//       })
//       .catch((err) => {
//         console.error("Leave API Error:", err);

//         // fallback static data
//         setUsers([
//           {
//             leaveType: "Casual Leave",
//             department: "HR",
//             duration: "2 Days",
//             appliedDate: "12-01-2026",
//             status: "Pending",
//           },
//           {
//             leaveType: "Sick Leave",
//             department: "IT",
//             duration: "1 Day",
//             appliedDate: "10-01-2026",
//             status: "Approved",
//           },
//           {
//             leaveType: "Paid Leave",
//             department: "Admin",
//             duration: "3 Days",
//             appliedDate: "09-01-2026",
//             status: "Rejected",
//           },
//         ]);
//       });
//   }, []);

//   return (
//     <section>
//       <Breadcrumb
//         routeSegments={[
//           { name: "Dashboard", path: "/" },
//           { name: "Employees", path: "/employees" },
//           { name: "Leave" },
//         ]}
//       />

//       <Card body>
//         <Card.Title>Leave Info</Card.Title>

//         {users.length > 0 && (
//           <RBTable
//             data={users}
//             columns={columns}
//             varient="primary"
//             header={{
//               enableFilters: true,
//               enableGlobalFilter: true,
//               enableDensityToggle: true,
//               enableExportButton: true,
//             }}
//             footer={{
//               enablePagination: true,
//               pageSize: 5,
//               pageSizeOptions: [5, 10, 20, 50],
//             }}
//           />
//         )}
//       </Card>
//     </section>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import Card from "react-bootstrap/Card";
import { RBTable } from "@pallassystems/react-bootstrap-table";
import Breadcrumb from "app/components/Breadcrumb";
import { axios } from "fake-db/mock";

export default function Leave() {
  const [users, setUsers] = useState([]);

  // Define columns here
  const columns = useMemo(
    () => [
      { accessorKey: "leaveType", header: "Leave Type", searchable: true },
      { accessorKey: "department", header: "Department", searchable: true },
      { accessorKey: "duration", header: "Duration" },
      { accessorKey: "appliedDate", header: "Applied Date" },
      { accessorKey: "status", header: "Status", searchable: true },
    ],
    []
  );

  useEffect(() => {
    axios
      .get("/api/user/all")
      .then((res) => {
        console.log("Leave API Response:", res.data);

        // Map API response to table structure
        const leaveTypes = ["Casual Leave", "Sick Leave", "Paid Leave"];
        const departments = ["HR", "IT", "Admin", "Sales"];
        const durations = ["1 Day", "2 Days", "3 Days"];
        const statuses = ["Pending", "Approved", "Rejected"];

        const list = (res.data || []).map((user, index) => ({
          leaveType: leaveTypes[index % leaveTypes.length],
          department: departments[index % departments.length],
          duration: durations[index % durations.length],
          appliedDate: `0${(index % 9) + 1}-01-2026`, // 01-01-2026 to 09-01-2026
          status: statuses[index % statuses.length],
        }));

        setUsers(list);
      })
      .catch((err) => {
        console.error("Leave API Error:", err);

        // fallback static data
        setUsers([
          {
            leaveType: "Casual Leave",
            department: "HR",
            duration: "2 Days",
            appliedDate: "12-01-2026",
            status: "Pending",
          },
          {
            leaveType: "Sick Leave",
            department: "IT",
            duration: "1 Day",
            appliedDate: "10-01-2026",
            status: "Approved",
          },
          {
            leaveType: "Paid Leave",
            department: "Admin",
            duration: "3 Days",
            appliedDate: "09-01-2026",
            status: "Rejected",
          },
        ]);
      });
  }, []);

  return (
    <section>
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Employees", path: "/employees" },
          { name: "Leave" },
        ]}
      />

       <Card body>
        <Card.Title>Leave Info</Card.Title>

        {users.length > 0 && (
          <RBTable
            data={users}
            columns={columns}
            varient="primary"
            footer={{ enablePagination: true }}
            toolbar={{
              enableFilters: true,
              enableGlobalFilter: true,
              enableDensityToggle: true,
              enableExportButton: true,
            }}
          />
        )}
      </Card>
    </section>
  );
}
